// extracted by mini-css-extract-plugin
export var externalLink = "_b0-0";
export var internalLinkLabel = "_b0-1";